import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PasswordResetForm } from '../components/auth/PasswordResetForm';
import { SetNewPasswordForm } from '../components/auth/SetNewPasswordForm';
import { ROUTES } from '../utils/constants';

export function PasswordResetPage() {
  const { t } = useTranslation('auth');
  const [searchParams] = useSearchParams();
  const hasToken = searchParams.has('token');

  const titleKey = hasToken ? 'setNewPassword.title' : 'resetPassword.title';
  const subtitleKey = hasToken ? 'setNewPassword.subtitle' : 'resetPassword.subtitle';

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 py-12 px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <Link to={ROUTES.HOME} className="inline-flex items-center gap-2 mb-6">
            <div className="w-10 h-10 bg-primary-700 rounded flex items-center justify-center">
              <span className="text-white font-bold text-xl">W</span>
            </div>
            <span className="text-2xl font-bold text-neutral-900">{t('common:appName')}</span>
          </Link>
          <h1 className="text-3xl font-bold text-neutral-900 mb-2">{t(titleKey)}</h1>
          <p className="text-neutral-600">{t(subtitleKey)}</p>
        </div>

        <div className="bg-white p-8 rounded-lg shadow-sm border border-neutral-200">
          {hasToken ? <SetNewPasswordForm /> : <PasswordResetForm />}

          <div className="mt-6 text-center text-sm text-neutral-600">
            {t('resetPassword.rememberPassword')}{' '}
            <Link to={ROUTES.LOGIN} className="text-primary-700 hover:text-accent-600 font-medium">
              {t('resetPassword.login')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
